import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationUpdateContinuousOptimizationSegmentArgs,
  BackendSegment,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateContinuousOptimizationSegment($id: ID!, $keywords: [String!]) {
    updateContinuousOptimizationSegment(id: $id, keywords: $keywords) {
      id
      keywords
    }
  }
`;

type Variables = BackendMutationUpdateContinuousOptimizationSegmentArgs;
type Result = Pick<BackendSegment, 'id' | 'keywords'>;

export const updateContinuousOptimizationSegment = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
